import React from 'react';
import "../../../styles/index.scss"
import css from './CommonInput.module.scss'
import {NavLink} from "react-router-dom";
import eye from '../../../images/eye.svg'
import {Field} from "formik";
import {useTheme} from "../../../App";
import {useTranslation} from "react-i18next";

const CommonInput = ({caption, type, value, setValue, id, isPassword, isShowPassword, setIsShowPassword, error, isShowForgot}) => {
  const {isDark} = useTheme()
  const {t} = useTranslation()
  return (
    <div className={`${css.inputBlock} ${isDark && `${css.inputBlock__dark}`}`}>
      <div className={css.title}>
        <p className={css.label}>
          {caption}
        </p>
        {isShowForgot && <NavLink className={css.forgot} to={'/logbook/auth/recovery'}>{t('isForgotPass')}</NavLink>}
      </div>
      <div className={css.inputWrapper}>
        <Field id={id} type={(!isShowPassword) ? type : 'text'} value={value} onChange={setValue}
               className={`${css.input} ${error && 'modal__inputError'}`}/>
        {isPassword && <button type={'button'} className={css.showPassword} onClick={setIsShowPassword}>
          <img src={eye} alt=""/>
        </button>}
      </div>
      {error && <p className="modal__errorText">{error}</p>}
    </div>
  );
};

export default React.memo(CommonInput);
